/**
 * Currency reducer.
 * @module reducers/currency/currency
 */

import { SET_CURRENCY } from '../../actions/currency/currency';

const initialState = 'USD';

/**
 * Currency reducer. Holds the currency ('USD' or 'EUR') used to display
 * prices throughout the app, shared between the sidebar toggle and any
 * view that renders a price.
 * @function currency
 * @param {string} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {string} New state.
 */
export default function currency(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CURRENCY:
      return action.currency;
    default:
      return state;
  }
}
